module.exports = "/img/_/_/_/assets/images/creeper/battle/common//20.jpg?69054681f4e0eec0a07e91f74d48495e";